import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        @media (max-width: 768px) {
            padding: 40px 16px;
        }

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.2em;
                }

                @media (max-width: 480px) {
                    font-size: 1.75em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;

        @media (max-width: 768px) {
            font-size: 0.95em;
            gap: 6px;
        }
        
        a, span {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1200px;
        margin: -40px auto 0;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        gap: 40px;
        position: relative;
        z-index: 10;
        box-sizing: border-box;

        @media (max-width: 768px) {
            margin: -24px auto 0;
            padding: 0 12px;
            gap: 24px;
        }
        
        .profile-card {
            background: #ffffff;
            border-radius: 24px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0,0,0,0.04);
            display: flex;
            flex-direction: row;
            overflow: hidden;
            
            @media (max-width: 900px) {
                flex-direction: column;
                border-radius: 18px;
            }

            .profile-sidebar {
                width: 350px;
                background: linear-gradient(to bottom, #ffffff, #f0fbfc);
                padding: 40px 30px;
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                border-right: 1px solid rgba(0,0,0,0.04);
                box-sizing: border-box;
                
                @media (max-width: 900px) {
                    width: 100%;
                    border-right: none;
                    border-bottom: 1px solid rgba(0,0,0,0.04);
                    padding: 24px 16px;
                }

                .avatar-wrapper {
                    width: 200px;
                    height: 200px;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-bottom: 25px;
                    border: 6px solid #e0f2fe;
                    box-shadow: 0 10px 25px rgba(0,169,196,0.15);

                    @media (max-width: 600px) {
                        width: 140px;
                        height: 140px;
                        margin-bottom: 16px;
                    }
                    
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        object-position: top;
                    }
                }

                h2 {
                    font-size: 1.8em;
                    color: #0369a1;
                    margin: 0 0 15px 0;
                    font-weight: 800;

                    @media (max-width: 600px) {
                        font-size: 1.4em;
                    }
                }

                .tags {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    width: 100%;
                    margin-bottom: 25px;

                    .badge {
                        padding: 8px 16px;
                        border-radius: 20px;
                        font-size: 0.9em;
                        font-weight: 600;

                        &.primary {
                            background: #e0f2fe;
                            color: #0ea5e9;
                        }
                    }
                }
            }

            .profile-body {
                flex: 1;
                padding: 50px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                box-sizing: border-box;

                @media (max-width: 900px) {
                    padding: 24px 16px;
                }
                
                .cv-body {
                    width: 100%;
                    
                    h2, p, span, li, a {
                        line-height: 1.6;
                        color: #334155;
                    }
                    
                    p {
                        font-size: 1.05em;
                        margin-bottom: 20px;

                        @media (max-width: 600px) {
                            font-size: 1em;
                            line-height: 1.65;
                        }
                        
                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                    
                    h3 {
                        font-size: 1.4em;
                        color: #0369a1;
                        margin: 40px 0 20px 0;
                        font-weight: 700;
                        border-bottom: 2px solid #f1f5f9;
                        padding-bottom: 10px;

                        @media (max-width: 600px) {
                            font-size: 1.25em;
                            margin: 24px 0 14px 0;
                        }
                    }

                    ul, ol {
                        padding-left: 20px;
                        margin-bottom: 20px;
                        
                        li {
                            margin-bottom: 10px;
                            font-size: 1.05em;

                            @media (max-width: 600px) {
                                font-size: 0.95em;
                            }
                            
                            &::marker {
                                color: #00A9C4;
                                font-weight: bold;
                            }
                        }
                    }
                    
                    a {
                        color: #0ea5e9;
                        text-decoration: underline;
                        
                        &:hover {
                            color: #0284c7;
                        }
                    }
                }
            }
        }
    `
};

export default S;